import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export interface AccessCard {
  id: number;
  renter_id: number;
  owner_id: number;
  user_id: number;
  card_uid: string;
}

export interface CreateAccessCardParams {
  device_id: number;
}

export function AccessCardsAPI(baseUrl: string) {
  return {
    list: async () => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.get(
        `${baseUrl}/access-cards?renter_id=${renterId}`,
        undefined,
        true,
      )) as ApiResponse<AccessCard[]>;
    },
    create: async (params: CreateAccessCardParams) => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.post(
        `${baseUrl}/access-cards?renter_id=${renterId}`,
        params,
        true,
      )) as ApiResponse<string>;
    },
    delete: async (id: number) => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.delete(
        `${baseUrl}/access-cards/${id}?renter_id=${renterId}`,
        true,
      )) as ApiResponse<string>;
    },
  };
}
